<template>
  <b-row class="mt-2"
         v-if="addresses.length !== 0">
    <b-col>
      <b-card class="rounded-0">
        <h4>
          {{ $t('message.adminUserAddress.title') }}
        </h4>

        <b-table striped
                 responsive
                 :fields="fields"
                 :items="addresses"
                 tbody-class="text-muted">
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'AdminUserAddress',
    created () {
      if (!this.addresses.length) {
        const id = parseInt(this.$route.params.id)
        this.$store.dispatch('fetchAdminAddresses', id).then(() => {
          this.addresses = this.$store.getters.adminAddresses
        })
      }
    },
    data () {
      return {
        fields: [{
          key: 'city',
          label: this.$t('message.adminUserAddress.table.city')
        }, {
          key: 'street',
          label: this.$t('message.adminUserAddress.table.street')
        }, {
          key: 'streetNumber',
          label: this.$t('message.adminUserAddress.table.streetNumber')
        }, {
          key: 'postalCode',
          label: this.$t('message.adminUserAddress.table.postalCode')
        }],
        addresses: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserAddress.vue